import React, { useEffect, useState } from 'react'
import { GetDetail, Update } from '../../web_api/api'
import { Link, useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'
import 'react-photo-view/dist/react-photo-view.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { FaImages } from "react-icons/fa";
import { FiChevronRight } from 'react-icons/fi'
import '../../branch/branch.css'

const PAGE_OPTIONS = ['Home', 'About Us', 'Our Services', 'Promos', 'Testimonials', 'Activities', 'Blog', 'Contacts']

export default function BannerCreate() {
    const location = useLocation()
    const ID = location.pathname.split('/')[2]
    const [imgUrl, setImgUrl] = useState('')
    const [page, setPage] = useState('')
    const [description, setDescription] = useState('')
    const [newImage, setNewImage] = useState(null)
    const [localPreview, setLocalPreview] = useState('')

    const handleImageChange = (e) => {
        const file = e.target.files[0]
        if (file) {
            setNewImage(file)
            setLocalPreview(URL.createObjectURL(file))
        }
    }

    const create = async () => {
        const formData = new FormData()
        formData.append('banners', newImage ? newImage : imgUrl)
        formData.append('page', page)
        formData.append('description', description)

        if (!newImage && !imgUrl) {
            Swal.fire({
                title: 'Need Image!',
                text: 'Try again!',
                icon: 'error',
                showConfirmButton: false,
                timer: 2000
            })
        } else {
            await Update('/banner-photo/', ID, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        }
    }

    useEffect(() => {
        const getList = async () => {
            const res = await GetDetail('banner-photo/', ID)
            setImgUrl(res.data.imgUrl)
            setPage(res.data.page)
            setDescription(res.data.description)
        }
        getList()
    }, [])

    return (
        <div className='branch-page'>
            <div className='branch-breadcrumb'>
                <Link to='/treatment-dashboard'>Banner</Link>
                <FiChevronRight className='separator' size={14} />
                <span className='current'>Update Banner</span>
            </div>

            <div className='branch-card'>
                <div className='branch-card-body'>
                    <div className='branch-form-grid'>
                        <div>
                            <div className='branch-form-section'>
                                <div className='branch-form-section-title'>Banner Details</div>
                                <div className='branch-field'>
                                    <label className='branch-field-label' htmlFor='tn'>Image</label>
                                    <input type='file' id='tn' className='branch-input' onChange={handleImageChange} />
                                </div>
                                <div className='branch-field'>
                                    <label className='branch-field-label' htmlFor='page'>Page</label>
                                    <select id='page' className='branch-select' value={page} onChange={(e) => setPage(e.target.value)}>
                                        <option value=''>Select Page</option>
                                        {PAGE_OPTIONS.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                                    </select>
                                </div>
                                <div className='branch-field'>
                                    <label className='branch-field-label' htmlFor='description'>Description</label>
                                    <input type='text' id='description' value={description} className='branch-input' onChange={(e) => setDescription(e.target.value)} />
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className='branch-form-section'>
                                <div className='branch-form-section-title'>Image Preview</div>
                                <div className='branch-field'>
                                    { (localPreview || imgUrl) && (
                                        <div className='branch-preview-grid'>
                                            <div className='branch-preview-item' style={{ width: '200px', height: '150px' }}>
                                                <PhotoProvider>
                                                    <PhotoView src={localPreview || imgUrl}>
                                                        <img src={localPreview || imgUrl} alt='preview' style={{cursor: 'pointer', width: '100%', height: '100%', objectFit: 'cover'}} />
                                                    </PhotoView>
                                                </PhotoProvider>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='branch-form-footer'>
                        <Link to='/treatment-dashboard' className='branch-btn branch-btn-outline'>Cancel</Link>
                        <button className='branch-btn branch-btn-primary' onClick={create}>Update</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
